import PropTypes from "prop-types";

import {
  KeyStatsContainer,
  NoDataMessage,
} from "features/Strategy/v2/Detail/StrategyDetails.styles";

// import { getCleanLabel } from "utils";
// import { Tooltip } from "components/Tooltip";
import KeyStatsPlaceholder from "./Placeholders/KeyStatsPlaceholder";
// import { Button } from "components/Button";
import { KeyStatsModal } from "./KeyStatsModal";

const getFormattedValue = (value) => {
  if (value === "True") {
    return "Yes";
  } else if (value === "False") {
    return "No";
  }

  return value;
};

const KeyStats = ({
  stats = [],
  isLoading,
  showKeyStatsModal,
  setshowKeyStatsModal,
}) => {
  if (isLoading) {
    return <KeyStatsPlaceholder />;
  }

  const toggleViewMoreModal = () => {
    setshowKeyStatsModal(!showKeyStatsModal);
  };

  return (
    <KeyStatsContainer>
      {!stats?.length && (
        <NoDataMessage className="no-data">
          No Key Statistics found
        </NoDataMessage>
      )}
      {stats?.length > 0 && (
        <>
          <ul>
            {stats.slice(0, 8).map((data, i) => {
              // const label = getCleanLabel(data.description);
              // if (i === 7) {
              //   return (
              //     <li key={"view-more"} className="button-wrapper">
              //       <Button
              //         className="button-outlined view-more"
              //         onClick={toggleViewMoreModal}
              //       >
              //         View more
              //       </Button>
              //     </li>
              //   );
              // }

              return (
                <li key={i}>
                  <div className="label-wrapper">
                    <span className="key text-ellipsis">
                      <span className="label">{data.name}</span>
                      {/* <Tooltip
                        placement="auto"
                        value={label}
                        tooltipClassName="v2-tooltip"
                      /> */}
                    </span>
                  </div>
                  <span className="stats">
                    {getFormattedValue(data?.value)}
                  </span>
                </li>
              );
            })}
          </ul>
          {showKeyStatsModal && (
            <KeyStatsModal
              show={showKeyStatsModal}
              onHide={toggleViewMoreModal}
              stats={stats}
              getFormattedValue={getFormattedValue}
            />
          )}
        </>
      )}
    </KeyStatsContainer>
  );
};

export default KeyStats;

KeyStats.propTypes = {
  stats: PropTypes.array,
  isLoading: PropTypes.bool,
  showKeyStatsModal: PropTypes.boolean,
  setshowKeyStatsModal: PropTypes.func,
};
